import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Table, TableHead, TableRow, TableCell, TablePagination, TableSortLabel } from "@material-ui/core";
import "../styles/user.scss";

let count = 0;

export default function useTable(records, headCells, filterFn, selectedList,tableClassname= "") {
  const pages = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  count = _.size(records);
  
  useEffect(() => {
    setPage(0);
  }, [selectedList, filterFn]);

  const TblContainer = (props) => <Table className={`userTable ${tableClassname}`}>{props.children}</Table>;

  const TblHead = (_props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
      setPage(0);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              style={_.has(headCell, "width") ? { width: headCell.width } : null}
              sortDirection={orderBy === headCell.id ? order : false}>
              {headCell.disableSorting ? (
                headCell.label
              ) : (
                <TableSortLabel
                  className="tableSortLabel"
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={() => {
                    handleSortRequest(headCell.id);
                  }}>
                  {headCell.label}
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <TablePagination
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={count}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      nextIconButtonText="Next Page"
      backIconButtonText="Previous Page"
      className="tablePagination"
      classes={{
        toolbar: "tablePaginationToolbar"
      }}
    />
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const orderComparator = comparator(a[0], b[0]);
      if (orderComparator !== 0) return orderComparator;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(orderComparator, orderByComparator) {
    return orderComparator === "desc"
      ? (a, b) => descendingComparator(a, b, orderByComparator)
      : (a, b) => -descendingComparator(a, b, orderByComparator);
  }

  function descendingComparator(a, b, orderByComparator) {
    if (_.isEmpty(orderByComparator) && !_.isEmpty(headCells)) {
      orderByComparator = headCells[1].id;
    }
    try {
      if (_.get(a, orderByComparator) === null || _.isEmpty(_.get(a, orderByComparator))) {
        return -1;
      }
      if (_.get(b, orderByComparator) === null || _.isEmpty(_.get(b, orderByComparator))) {
        return 1;
      }
      if (_.get(b, orderByComparator, "").toString().toLowerCase() < _.get(a, orderByComparator, "").toString().toLowerCase()) {
        return -1;
      }
      if (_.get(b, orderByComparator, "").toString().toLowerCase() > _.get(a, orderByComparator, "").toString().toLowerCase()) {
        return 1;
      }
      return 0;
    } catch (e) {}
  }
  const isVisible = () => {
    let result = stableSort(filterFn.fn(records), getComparator(order, orderBy));
    count = _.size(result);
    return _.size(result) > 0;
  };

  const recordsAfterPagingAndSorting = () => {
    return stableSort(filterFn.fn(records), getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      (page + 1) * rowsPerPage
    );
  };

  return {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    isVisible,
  };
}
